import { render } from "./AnswerPage.vue?vue&type=template&id=8533a65a&scoped=true"
import script from "./AnswerPage.vue?vue&type=script&lang=js"
export * from "./AnswerPage.vue?vue&type=script&lang=js"

import "./AnswerPage.vue?vue&type=style&index=0&id=8533a65a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8533a65a"],['__file',"src/components/project/AnswerPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8533a65a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8533a65a', __exports__)) {
    api.reload('8533a65a', __exports__)
  }
  
  module.hot.accept("./AnswerPage.vue?vue&type=template&id=8533a65a&scoped=true", () => {
    api.rerender('8533a65a', render)
  })

}


export default __exports__